import { UIClientFetchError, UIFetchStatus, UISearchMinPriceInfo } from "@flights/types";

export type State = {
  fetchStatus: UIFetchStatus;
  flexibleDateMinPrice: UISearchMinPriceInfo[];
  error?: UIClientFetchError;
};

export const getInitialState = (): State => ({
  fetchStatus: "initial",
  flexibleDateMinPrice: [],
  error: undefined
});
